import React, {useState, useEffect} from "react";
import DefaultSelect from "../More/DefaultSelect";
import ProductSection from "../../components/Product/ProductSection";
import PaginationSection from "../../components/Product/Pagination";
import { useNavigate, useSearchParams } from 'react-router-dom';
import instance from "../../services/services";
import { BRAND_DETAIL_URL } from "../../utils/urls";
import { useLanguage } from "../../hooks/useLanguage";

function BrandPageSec(){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // URL 파라미터에서 데이터 가져오기
  const brand_code = searchParams.get('brand_code');
  const category_code = searchParams.get('category_code');
  const member_seq = searchParams.get('member_seq');
  const category_name = searchParams.get('category_name');
  const currentSortParam = searchParams.get('currentSort');
  const currentPageParam = searchParams.get('currentPage');
  const brand_seq = searchParams.get('brand_seq');
  
  const [detailData, setDetailData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(parseInt(currentPageParam) || 1);
  const [totalCount, setTotalCount] = useState(0);
  const [currentSort, setCurrentSort] = useState(currentSortParam || "regist_date");
  const itemsPerPage = 30;
  const [brandInfo, setBrandInfo] = useState([]);

  useEffect(()=> {
    // 필수 파라미터 체크
    if (!brand_code || !category_code) {
      alert("필수 파라미터가 없습니다.");
      navigate('/');
      return;
    }

    const getBrandDetail = async () => {
      try {
        setLoading(true);
        const response = await instance.post(BRAND_DETAIL_URL, {
          brand_code: brand_code,
          member_seq: member_seq,
          category_code: category_code,
          newpage_check: "",
          offset: currentPage,
          searchSort: currentSort
        });
        setBrandInfo(response.data.data.categoryInfo);
        setDetailData(response.data.data.data || []);
        setTotalCount(parseInt(response.data.data.cntRow || 0));
        setLoading(false);
      } catch (error) {
        console.error("브랜드 상세 조회 오류: " + error.message);
        setLoading(false);
      }
    };
    getBrandDetail();
  }, [brand_code, member_seq, category_code, currentPage, currentSort, navigate]);

  const handleSortChange = (value) => {
    setCurrentSort(value);
    setCurrentPage(1);
  };

  // 페이지 변경 핸들러 추가
  const handlePageChange = (page) => {
    setCurrentPage(page);
    // window.scrollTo(0, 0); // 페이지 상단으로 스크롤
  };

  // 화살표 클릭 핸들러 추가
  const handleArrowClick = (page) => {
    handlePageChange(page);
  };

  // breadcrumb 클릭 핸들러 수정
  const handleBrandCodeClick = () => {
    navigate(`/category/brandPage?title=${brand_code}&brand_seq=${brand_seq || ''}`);
  };

  const BeforeContent = () => (
    <div className="auth_find" style={{marginBottom:"-16px"}}>
        <div className="product_total">
            {t('product_total_count', {count: totalCount})}
        </div>
        <DefaultSelect  
            defaultValue={currentSort}
            onChange={handleSortChange}
        />
    </div>
  );

  const AfterContent = () => (
    <div className="pagination_wrap">
        <PaginationSection
            totalCount={totalCount}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onArrow={handleArrowClick}
        />
    </div>
  );
  return(
    <div>
      <section className="prod_section">
        <div 
          className=" product_banner cate_brand"
          style={{backgroundImage:`url(${window.innerWidth > 768 ? brandInfo?.pc_img_url : brandInfo?.mobile_img_url})`}}
        >
          <div className="inner">
            <ul className="bread_crumb">
              <li className="group_item">
                <p>HOME</p>
              </li>
              <li className="group_item">
                <p>BRAND</p>
              </li>
              <li className="group_item" style={{cursor: 'pointer'}} onClick={handleBrandCodeClick}>
                <p>{brand_code}</p>
              </li>
              <li className="group_item active">
                <p>{category_name || "카테고리명 없음"}</p>
              </li>
            </ul>
            
            <div className="product_tit">
              <h4 className="tit">BRAND</h4>
              <p className="sub">{brandInfo?.cate_comment}</p>
            </div>
          </div>

        </div>

        <div className="inner main_prod_list cate_container">
          
          {/* 상단 */}
          <div className="brand_top_tab">
            <div className="brand_section_title">
              {category_name || "카테고리명 없음"}
            </div>
          </div>

          <div className="p0">
            {loading ? (
              <div className="loading-overlay">
                <div className="loading">로딩 중...</div>
              </div>
            ) : detailData.length > 0 ? (
              <ProductSection
                products={detailData}
                showTabs={false}
                showMoreButton={false}
                beforeContent={<BeforeContent />}
                afterContent={<AfterContent />}
                useSwiper={false}
              />
            ) : (
              <div className="no_result">
                <p>{t('no_product_found')}</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  )
};

export default BrandPageSec;